// Copyright 2019 Sorama B.V.

import { autoinject } from "aurelia-framework";
import { Router } from "aurelia-router";
import { ParserCatalog } from "parsers/ParserCatalog";
import { IUrlStateService } from "./Interfaces/IUrlStateService";
import { IWorkflowPropertyParser } from "./Interfaces/IWorkflowPropertyParser";
import { WorkflowProperty } from "./WorkflowProperties/WorkflowPropertyObserverManager";
import {
    WorkflowPropertyUriConverter,
    WorkflowUriModule,
    WorkflowUriProperty,
} from "./WorkflowProperties/WorkflowPropertyUriConverter";

@autoinject
export class UrlStateService implements IUrlStateService {
    constructor(private readonly router: Router) {}

    public updateNavigationState(workflowName: string, uriModules: WorkflowUriModule[], replace = false): void {
        const newUri = WorkflowPropertyUriConverter.workflowModulesToUri(uriModules);
        const uri = workflowName + newUri + window.location.search;
        this.router.navigate(uri, { trigger: false, replace: replace });
    }

    public getNavigationState(): WorkflowUriModule[] {
        return WorkflowPropertyUriConverter.workflowModulesFromUri(new URL(window.location.href));
    }

    public updatePropertyState(workflowProperties: WorkflowProperty[]): void {
        const updatedSearchParams = WorkflowPropertyUriConverter.WorkflowPropertiesToQuery(
            workflowProperties,
            this.getPropertyParsers()
        );
        const searchParams = new URLSearchParams(window.location.search);

        // Update the query string
        for (const param of updatedSearchParams) {
            searchParams.set(param[0], param[1]);
        }

        // Update the URI, without triggering the whole pipeline
        let searchParamsString = searchParams.toString();
        searchParamsString = searchParamsString ? "?" + searchParamsString : searchParamsString;

        this.router.navigate(window.location.pathname + searchParamsString, { trigger: false, replace: true });
    }

    public deletePropertyStates(prefix: string): void {
        const searchParams = new URLSearchParams(window.location.search);

        // Update the query string
        const keys: string[] = [...searchParams.keys()];
        for (const key of keys) {
            const paramPrefix = WorkflowPropertyUriConverter.getPrefix(key);
            if (prefix == undefined || prefix == paramPrefix) {
                searchParams.delete(key);
            }
        }

        // Update the URI, without triggering the whole pipeline
        let searchParamsString = searchParams.toString();
        searchParamsString = searchParamsString ? "?" + searchParamsString : searchParamsString;

        this.router.navigate(window.location.pathname + searchParamsString, { trigger: false, replace: true });
    }

    public getPropertyState(prefix: string): WorkflowUriProperty[] {
        const params = new URLSearchParams(window.location.search);
        return WorkflowPropertyUriConverter.urlToWorkflowProperties(params, this.getPropertyParsers()).filter(
            (x) => prefix == undefined || x.prefix == prefix
        );
    }

    private getPropertyParsers(): { [objectName: string]: IWorkflowPropertyParser<unknown> } {
        return ParserCatalog.Parsers;
    }
}
